import { render, staticRenderFns } from "./FrameDialogs.vue?vue&type=template&id=6a7cc824&"
import script from "./FrameDialogs.vue?vue&type=script&lang=ts&"
export * from "./FrameDialogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports